import {
  Box,
  Container,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  styled,
  Paper,
  TableBody,
  Stack,
  Grid,
} from '@mui/material';
import {HeaderTag, HeaderText, RoundedButton} from 'components';
import {tableCellClasses} from '@mui/material/TableCell';
import {blue} from 'styles/color';
import {useMatchesSize} from 'common/useMatchesSize';
import {useTranslation} from 'react-i18next';
import {TopTokenInfo} from './TopTokenInfo';
import {useHistory} from 'react-router-dom';

const MarketPrices = () => {
  const rows = TopTokenInfo();
  const {isMedium, isSmall} = useMatchesSize();
  const {t} = useTranslation();
  const history = useHistory();
  return (
    <Box mb={20}>
      <Container sx={{px: {md: 0}}}>
        <HeaderTag
          label={t('homepage.market.asset')}
          sx={{marginBottom: 3.5, display: isSmall ? 'none' : 'inline-flex'}}
        />
        <HeaderText mb={8.5} isSmall={false}>
          {t('homepage.market.title')}
        </HeaderText>
      </Container>

      <Container sx={{paddingX: 0}}>
        <div></div>

        {isSmall || isMedium ? MobileTable(rows) : DesktopTable(rows)}

        <Stack justifyContent="center" direction="row">
          <RoundedButton
            variant="contained"
            hasIcon
            onClick={() => history.push('/buy-credit-card')}>
            {t('homepage.market.see_all')}
          </RoundedButton>
        </Stack>
      </Container>
    </Box>
  );
};

const DesktopTable = (rows) => {
  const {t} = useTranslation();
  return (
    <TableContainer
      component={Paper}
      elevation={0}
      sx={{mb: 8, fontFamily: ['Noto Sans', 'sans-serif'].join(', ')}}>
      <Table
        sx={{
          minWidth: 700,
        }}>
        <StyledTableHead>
          <TableRow>
            <StyledTableCell>{t('homepage.market.name_token')}</StyledTableCell>
            <StyledTableCell align="center">
              {t('homepage.market.price')}
            </StyledTableCell>
            <StyledTableCell align="center">
              {t('homepage.market.change_24h')}
            </StyledTableCell>
            {/* <StyledTableCell align="center">{t("homepage.market.chart")} </StyledTableCell> */}
            <StyledTableCell align="right">
              {t('homepage.market.market_cap')}
            </StyledTableCell>
          </TableRow>
        </StyledTableHead>
        <TableBody>
          {rows &&
            rows.map((row) => (
              <TableRow key={row.crypto}>
                <StyledTableCell component="th" scope="row">
                  <Stack direction="row" alignItems="center" spacing={3.5}>
                    <img src={row.icon} alt="" />
                    <span>{row.crypto}</span>
                  </Stack>
                </StyledTableCell>
                <StyledTableCell align="center">{`$${row.price}`}</StyledTableCell>
                <StyledTableCell align="center">
                  <HeaderTag
                    color={row.percentageChange > 0 ? 'success' : 'error'}
                    label={`${row.percentageChange}%`}
                    sx={{
                      borderRadius: '5px',
                      paddingX: 0,
                      width: (theme) => theme.spacing(12),
                      fontWeight: 500,
                      fontSize: (theme) => theme.spacing(2.25),
                    }}
                  />
                </StyledTableCell>
                {/* <StyledTableCell align="center">
              {row.chartData}
            </StyledTableCell> */}
                <StyledTableCell align="center">
                  {'$' + row.marketCap}
                </StyledTableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

const MobileTable = (rows) => {
  const {t} = useTranslation();
  return (
    <TableContainer component={Paper} elevation={0} sx={{mb: 8}}>
      <Table sx={{width: '100%'}}>
        <StyledTableHead>
          <TableRow>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell>{t('homepage.market.name_token')}</StyledTableCell>
            <StyledTableCell align="center">
              {t('homepage.market.price')}
            </StyledTableCell>
          </TableRow>
        </StyledTableHead>

        <TableBody>
          {rows &&
            rows.map((row) => (
              <TableRow key={row.crypto}>
                <StyledTableCell component="th" scope="row">
                  <img src={row.icon} alt="" />
                </StyledTableCell>

                <StyledTableCell component="th" scope="row">
                  <span>{row.crypto}</span>
                </StyledTableCell>

                <StyledTableCell align="center">
                  <Stack alignItems="center" spacing={1}>
                    <span>{`$${row.price}`}</span>
                    <HeaderTag
                      color={row.percentageChange > 0 ? 'success' : 'error'}
                      label={`${row.percentageChange}%`}
                      size="small"
                      sx={{
                        borderRadius: '5px',
                        paddingX: 0,
                        width: (theme) => theme.spacing(12),
                        fontWeight: 500,
                        fontSize: {
                          md: (theme) => theme.spacing(2),
                          xs: (theme) => theme.spacing(1.75),
                        },
                        width: (theme) => theme.spacing(8),
                      }}
                    />
                  </Stack>
                </StyledTableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

const StyledTableCell = styled(TableCell)(({theme}) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: blue[100],
    color: theme.palette.common.black,
    fontSize: theme.spacing(2),
    lineHeight: theme.spacing(2.5),
    fontWeight: 400,
    fontFamily: ['Noto Sans', 'sans-serif'].join(', '),
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: theme.spacing(2.25),
    fontWeight: 500,
    lineHeight: theme.spacing(2.4),

    fontFamily: ['Noto Sans', 'sans-serif'].join(', '),
    [theme.breakpoints.down('md')]: {
      fontSize: theme.spacing(1.75),
      lineHeight: theme.spacing(2.25),
      fontWeight: 400,
    },
  },
}));

const StyledTableHead = styled(TableHead)(({theme}) => ({
  borderColor: blue[100],
  borderLeftWidth: 100,
  borderRightWidth: 100,
  borderStyle: 'solid',
  fontFamily: ['Noto Sans', 'sans-serif'].join(', '),

  [theme.breakpoints.down('md')]: {
    borderLeftWidth: 30,
    borderRightWidth: 30,
  },
}));

export {MarketPrices};
